module.exports = __webpack_public_path__ + "static/media/ic-openMode-dark.ffd0a38d.svg";